import { NumberedBadge } from '@piccolohealth/ui';
import React from 'react';
import { useParticipantRestrictivePracticesQuery } from '../../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  participantId: string;
}

export const ParticipantRestrictivePracticesBadge = (props: Props) => {
  const { participantId } = props;
  const { organization } = useAppContext();

  const { data } = useParticipantRestrictivePracticesQuery({
    organizationId: organization.id,
    participantId,
  });

  const restrictivePractices = data?.organization?.participant?.restrictivePractices || [];

  return <NumberedBadge count={restrictivePractices.length} />;
};
